import { render, staticRenderFns } from "./TableRowsToChips.vue?vue&type=template&id=2cecc70a&scoped=true&"
import script from "./TableRowsToChips.vue?vue&type=script&lang=js&"
export * from "./TableRowsToChips.vue?vue&type=script&lang=js&"
import style0 from "./TableRowsToChips.vue?vue&type=style&index=0&id=2cecc70a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cecc70a",
  null
  
)

export default component.exports